import { EnvironmentVariable } from './app-settings'

export class ApiSettings {
  public readonly REACT_APP_WEBINARS_SERVICE_URL: string

  constructor(envVariables: EnvironmentVariable) {
    this.REACT_APP_WEBINARS_SERVICE_URL = envVariables.REACT_APP_WEBINARS_SERVICE_URL as string
  }
}
